import { render, staticRenderFns } from "./SantralStringsComparison.vue?vue&type=template&id=ccf28d5a&scoped=true&"
import script from "./SantralStringsComparison.vue?vue&type=script&lang=js&"
export * from "./SantralStringsComparison.vue?vue&type=script&lang=js&"
import style0 from "./SantralStringsComparison.vue?vue&type=style&index=0&id=ccf28d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf28d5a",
  null
  
)

export default component.exports